var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG---TieOut-Iconography",
    transform: "translate(-836.000000, -1837.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Cross-/-Special-<-24px",
    transform: "translate(831.000000, 1832.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Cross-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(5.500000, 5.500000)",
    fill: "#00a3e0",
    className: "icon-path-outer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-path-inner",
    d: "M6.10397516,5.46037267 L10.7840994,0.778881988 C10.9617391,0.601242236 10.9617391,0.314285714 10.7840994,0.136645963 C10.6064596,-0.0409937888 10.3195031,-0.0409937888 10.1418634,0.136645963 L5.46037267,4.81677019 L0.780248447,0.136645963 C0.602608696,-0.0409937888 0.314285714,-0.0409937888 0.136645963,0.136645963 C-0.0409937888,0.314285714 -0.0409937888,0.601242236 0.136645963,0.778881988 L4.81677019,5.46037267 L0.136645963,10.1404969 C-0.0409937888,10.3181366 -0.0409937888,10.6064596 0.136645963,10.7840994 C0.225465839,10.8729193 0.341614907,10.9167826 0.457900621,10.9167826 C0.575279503,10.9167826 0.691428571,10.8729193 0.780248447,10.7840994 L5.46037267,6.1026087 L10.1418634,10.7840994 C10.2308199,10.8729193 10.3468323,10.9167826 10.4629814,10.9167826 C10.5791304,10.9167826 10.6954161,10.8729193 10.7840994,10.7840994 C10.9617391,10.6064596 10.9617391,10.3181366 10.7840994,10.1404969 L6.10397516,5.46037267 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.83159b309dc2569c4452cd04cb483c45.svg";
export { ForwardRef as ReactComponent };